import { DocumentService } from "./DocumentService";
import { AppEntities, AppServices } from "../../config/entities";
import { IDistributionOfLandedCostsMethodEnum } from "../../enums/Documents/DistributionOfLandedCost/IDistributionOfLandedCostsMethodEnum";
import { DistributionOfLandedCostsRuleEnum } from "../../enums/Documents/DistributionOfLandedCost/DistributionOfLandedCostsRuleEnum";
import { DocumentPostStatusEnum } from "../../enums/DocumentPostStatusEnum";
import { v4 as uuid } from "uuid";
import { IDistributionOfLandedCostsProductDto } from "src/components/Pages/Documents/DistributionOfLandedCosts/dtos/IDistributionOfLandedCostsProductDto";
import { IDistributionOfLandedCostsModel } from "src/components/Pages/Documents/DistributionOfLandedCosts/models/IDistributionOfLandedCostsModel";

export class DistributionOfLandedCostsService extends DocumentService {
  async Clone(id: string) {
    const newObject = await this.Get(id);
    const clonedObject = { ...newObject };
    console.log("clonedObject is", clonedObject);
    return clonedObject;
  }

  async createBasedAtVendorInvoice(id: string): Promise<IDistributionOfLandedCostsModel> {
    const sourceDocumentDto = await AppEntities.VendorInvoices.getDataService().Get(id);
    const targetDocumentDto: IDistributionOfLandedCostsModel = {
      baseDocumentAtId: id,

      documentDate: new Date(),
      documentNumber: "",
      distributionMethod: IDistributionOfLandedCostsMethodEnum.Auto,
      companyId: sourceDocumentDto.companyId,
      divisionId: sourceDocumentDto.divisionId,

      vendorInvoices: [
        {
          distributionRule: DistributionOfLandedCostsRuleEnum.AccordingToTheQuantity,
          lineNo: 1,
          vendorInvoiceId: id,
          totalAmount: sourceDocumentDto.totalAmount
        }
      ],
      expenses: [],
      products: [],
      status: DocumentPostStatusEnum.Draft,
      id: uuid(),
      totalAmountVat: 0,
      totalAmount: sourceDocumentDto.totalAmount
    };

    targetDocumentDto.baseDocumentAtId = id;

    targetDocumentDto.documentDate = new Date();
    targetDocumentDto.documentNumber = "";
    targetDocumentDto.distributionMethod = IDistributionOfLandedCostsMethodEnum.Auto;
    targetDocumentDto.companyId = sourceDocumentDto.companyId;
    targetDocumentDto.divisionId = sourceDocumentDto.divisionId;

    targetDocumentDto.vendorInvoices = [];
    targetDocumentDto.vendorInvoices.push({
      distributionRule: DistributionOfLandedCostsRuleEnum.AccordingToTheQuantity,
      lineNo: 1,
      vendorInvoiceId: id,
      totalAmount: sourceDocumentDto.totalAmount
    });

    targetDocumentDto.totalAmount = sourceDocumentDto.totalAmount;

    return targetDocumentDto;
  }

  async getProductsFromVendorInvoices(requestDto: any): Promise<IDistributionOfLandedCostsProductDto[]> {
    const response = await AppServices.Axios.post("DistributionOfLandedCosts/GetProducts", requestDto);
    return response.data;
  }
}
